<template>
	<section>

		<user-notifications v-if="!isDoctor" v-model="confirmationRequests"></user-notifications>
		<coming-visit v-model="upcomingEvents" @more="loadEvents"></coming-visit>
		<user-events v-model="lastEvents"></user-events>

	</section>
</template>

<script>
	import moment from 'moment'

	export default {
		name: "MyEvents",
		computed: {
			isDoctor() {
				return this.$store.state.auth.isDoctor || this.$storage.isExist('worker')
			},
		},
		mounted() {
			if(!this.isDoctor) {
				this.getConfirmationRequests(this.$route.params.id);
			}

			this.getUpcomingEvents(this.$route.params.id, 5);
			this.getLastEvents(this.$route.params.id);

			this.$event.connect('updateEvents', () => {
				this.getUpcomingEvents(this.$route.params.id, 5)
			});

			this.$event.connect('updateNotifications', () => {
				this.getConfirmationRequests(this.$route.params.id, 5)
			});
		},
		data() {
			return {
				confirmationRequests: [],
				upcomingEvents: [],
				lastEvents: [],
				accessedTypes: [],
			}
		},
		methods: {
			getConfirmationRequests(id) {
				this.$store.dispatch('notification/list', {
					per_page: 5,
					to_user_id: id,
					types: ['^agenda.root.update(.status.not_confirmed)?(.begin.[0-9])?.[a-z_]*$'],
					status: 'created',
				}).then(response => {
					this.confirmationRequests = response.data
				})
			},
			getUpcomingEvents(id, count) {
				this.$store.dispatch('agenda/list', {
					begin: moment().format('YYYY-MM-DD'),
					per_page: count,
					status_array: ['not_confirmed', 'confirmed', 'came'],
					[(this.isDoctor) ? 'worker_ids' : 'user_ids']: [id],
				}).then(list => {
					this.upcomingEvents = list.data || []
				})
			},
			getLastEvents(id) {
				this.$store.dispatch('notification/list', {
					sort: 'desc',
					per_page: 5,
					types: ['^agenda.[a-z_]*.[a-z_]*(.status.not_appeared)?.[a-z_]*$'],
					[(this.isDoctor) ? 'to_worker_id' : 'to_user_id']: id,
				}).then(response => {
					this.lastEvents = response.data
				})
			},
			loadEvents(count) {
				this.getUpcomingEvents(this.$route.params.id, count)
			},
		},
		watch: {
			'$route': {
				handler(value) {
					this.getConfirmationRequests(value.params.id);
					this.getUpcomingEvents(value.params.id, 5);
					this.getLastEvents(value.params.id);
				},
				deep: true,
			},
		},
		beforeDestroy() {
			this.$event.disconnect(['updateEvents', 'updateNotifications']);
		},
	}
</script>



// WEBPACK FOOTER //
// Events.vue?579066fa